import React, { DetailedHTMLProps, FC, HTMLAttributes } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';

const useStyles = makeStyles({
    item: {
        flex: 1,
        overflowY: 'auto',
    },
});

export const LayoutGrowItem: FC<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = props => {
    const { className, ...rest } = props;

    const classes = useStyles();
    return (
        <div className={cn(classes.item, className)} {...rest}>
            {props.children}
        </div>
    );
};
